<template>
  <div class="view">
    <div class="companies" ref="companies">
      <a class="company" v-for="company in companies" :key="company.key" @click="selectedCompany = company">
        <CompanyCard :company="company" />
      </a>
    </div>
    <div class="overlay" :opened="Boolean(selectedCompany)" @click="selectedCompany = null">
      <div class="dialog" @click.stop>
        <a class="ic ic-close" @click="selectedCompany = null"></a>
        <CompanyCard v-if="selectedCompany" :company="selectedCompany" size="large" />
      </div>
    </div>
    <div class="add-button">
      <el-button @click="openNewCompany" type="primary" size="small" icon="el-icon-plus">Add your business</el-button>
    </div>
  </div>
</template>

<script>
import CompanyCard from './CompanyCard'

export default {
  name: 'CardView',
  components: {
    CompanyCard
  },
  data() {
    return {
      selectedCompany: null,
    }
  },
  props: {
    companies: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    companies() {
      this.$refs.companies.scrollTop = 0
    },
    selectedCompany(company) {
      if(company && company.key && window.location.host.includes('tourdefrance')) {
        this.db().ref(`/stats/perVenue/${company.key}`).transaction(stat => {
          return parseInt(stat || 0) + 1
        })
      }
    }
  },
  methods: {
    openNewCompany() {
      window.dispatchEvent(new CustomEvent('open-dialog', { detail: { dialog: 'company' } }))
    }
  }
}
</script>

<style scoped>
.view {
  display: flex;
  flex-direction: column;
}

.companies {
  position: relative;
  display: flex;
  height: 100%;
  flex-flow: row wrap;
  padding: 0 8px 16px;
  overflow: auto;
}

.companies .company {
  width: calc(25% - 16px);
  margin: 16px 8px 0;
}

.add-button {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  padding: 8px;
  background: rgba(0, 0, 0, .16);
  pointer-events: none;
}

.add-button .el-button {
  pointer-events: all;
}

@media screen and (max-width: 1170px) {
  .companies .company {
    width: calc(33.33333% - 16px);
  }
}

@media screen and (max-width: 950px) {
  .companies .company {
    width: calc(50% - 16px);
  }
}

@media screen and (max-width: 630px) {
  .companies {
    padding: 0 16px 16px;
  }
  .companies .company {
    width: 100%;
    margin: 16px 0 0;
  }
}
</style>
